var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"book-number-information text-size-md text-center mb-0",class:{
    active: _vm.isActive
  }},[_vm._v(" "+_vm._s(_vm.numberText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }